import { useState, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Container } from 'react-bootstrap'
import { MainContainer } from 'verak-ui'
import { useFetch } from '../../api/apihook'
import { Context } from '../../context/Provider'
import BasementTypeSelector from './basement/BasementTypeSelector'

function initData(state) {
	const { SubType, PrimaryOccupancy, levels, Level } = state

	if (SubType === 'Whole' && Level) {
		return {
			basementType: SubType,
			levels: [{ Level, PrimaryOccupancy }],
		}
	} else if ((SubType === 'Single' || SubType === 'Multiple') && levels?.length) {
		return {
			basementType: SubType,
			levels: levels,
		}
	}
	return null
}

export default function BasementLevelOccupancy() {
	const fetch = useFetch()

	const [state, dispatch] = useContext(Context)

	const [isInputComplete, setInputCompleteStatus] = useState(false)
	const [data, setData] = useState(initData(state?.location || {}))

	let history = useHistory()

	const goBack = () => {
		history.replace('/property-check')
	}

	const proceed = async () => {
		await new Promise((resolve, reject) => {
			dispatch({
				type: 'SET_BASEMENT_USAGE_AND_SUBTYPE',
				data: {
					SubType: data.basementType,
					levels: data.levels,
				},
			})
			resolve()
		})

		await new Promise((resolve, reject) => {
			dispatch({
				type: 'SAVE_LOCATION_CHANGES',
			})
			resolve()
		})

		await fetch.saveQuote()

		history.push('/property-risk/location-details')
	}

	const saveData = val => {
		setData(val)
	}

	return (
		<Container>
			<MainContainer
				header="Risk location occupancy"
				divider={false}
				leftOnClick={goBack}
				rightOnClick={proceed}
				rightDisabled={!isInputComplete}
			>
				<BasementTypeSelector setInputCompleteStatus={setInputCompleteStatus} saveData={saveData} />
			</MainContainer>
		</Container>
	)
}
